import React from "react";
import { Select } from "antd";
import { createGlobalStyle } from "styled-components";

const DROPDOWN_CLASS = "select-auto-width-dropdown";

// src/style.js applies a global, asymmetric padding to every AntD dropdown
// item (padding-right: 0, extra padding-left only), which is what makes
// option text look cramped against the right edge. This neutralizes that
// global rule for dropdowns rendered through this component only, with an
// equal, fixed value on both sides.
const DropdownGlobalStyle = createGlobalStyle`
  .${DROPDOWN_CLASS}.ant-select-dropdown .ant-select-item {
    padding: 16px 16px !important;
  }

  .${DROPDOWN_CLASS}.ant-select-dropdown .ant-select-item-option-content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

// AntD's Select defaults `dropdownMatchSelectWidth` to `true`, so the options
// panel inherits the (often narrow) trigger width and truncates option text.
// This preset turns that off so the panel sizes itself to fit its content.
const SelectAutoWidth = React.forwardRef(({ children, ...props }, ref) => (
  <>
    <DropdownGlobalStyle />
    <Select
      ref={ref}
      dropdownMatchSelectWidth={false}
      virtual={false}
      dropdownClassName={DROPDOWN_CLASS}
      {...props}
    >
      {children}
    </Select>
  </>
));

SelectAutoWidth.displayName = "SelectAutoWidth";
SelectAutoWidth.Option = Select.Option;

export default SelectAutoWidth;
